import { Injectable } from '@angular/core';


@Injectable()
export class HelperService {
    
    public isNullOrEmpty(text: any) : boolean {
        return !(typeof text != 'undefined' && text);
    }

    public format(fmtstr: string, args: string[]): string {
        return fmtstr.replace(/\{(\d+)\}/g, (match, index) => args[index]);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/services/common/helper.service.ts